import { render, staticRenderFns } from "./Quiz.vue?vue&type=template&id=84830ebe&scoped=true"
import script from "./Quiz.vue?vue&type=script&lang=js"
export * from "./Quiz.vue?vue&type=script&lang=js"
import style0 from "./Quiz.vue?vue&type=style&index=0&id=84830ebe&prod&scoped=true&lang=css"
import style1 from "./Quiz.vue?vue&type=style&index=1&id=84830ebe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84830ebe",
  null
  
)

export default component.exports